/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "1ada4c715a3641648b9decf7caea020a",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "1ada4c715a3641648b9decf7caea020a",
            "region": "us-east-1"
        }
    }
};


export default awsmobile;
